function formatTime(seconds): string {
	const minutes = Math.floor(seconds / 60);
	const remaining = seconds % 60;

	let reply = '';
	if (minutes < 10) {
		reply += '0'
	}
	reply += minutes;

	reply += ':';

	if (remaining < 10) {
		reply += '0';
	}
	reply += remaining;

	return reply;
}

export function Timer() {
	let startTime = 60 * 28 + 50;
	const element = document.querySelector('.countdown');

	setInterval(() => {
		if (startTime > 0) {
			startTime--;
		}

		element.innerHTML = formatTime(startTime);

	}, 1000)
}
